export const MilestoneBudgetType = [
    "Business Trips",
    "Training",
    "Materials",
    "Contracts",
    "Others",
];